export enum EPeriod {
  YEAR = 'YEAR',
  MONTH = 'MONTH',
  MONTHYEAR = 'MONTHYEAR',
  WEEK = 'WEEK',
  SEMESTER = 'SEMESTER',
}
